const I = {
  key: Symbol("DATA_VIEW_SORTING_INJECTION_KEY")
};
export {
  I as D
};
//# sourceMappingURL=DescriptionList.keys-BHlHYV6b.js.map
